import styled from 'styled-components';

const IconsContainer = styled.div`
  display: flex;
  gap: 20px;
  align-items: center;
  justify-content: center;
`;
export default IconsContainer;
